import React from "react";
import ProposalGeneratorModal from "../proposals/ProposalGeneratorModal";

/**
 * DealVoice Standard Proposal Generation Modal
 * Delegates to the full Ant Design side-by-side Proposal Generator with live preview.
 */
function ProposalModal({
  visible,
  open,
  onClose,
  onSaveProposal,
  prefillLead,
  initialLead,
  leadsList = [],
  companyCode,
  employeeId,
  collaboratingCompanies = [],
}) {
  const targetLead = prefillLead || initialLead || (leadsList.length > 0 ? leadsList[0] : null);

  return (
    <ProposalGeneratorModal
      visible={visible}
      open={open}
      onClose={onClose}
      lead={targetLead}
      companyCode={companyCode}
      collaboratingCompanies={collaboratingCompanies}
      onProposalSaved={onSaveProposal}
    />
  );
}

export default ProposalModal;
